<template>
  <div>
    <div class="mrB10" />
    <sui-grid
      ref="grid0"
      :dataset="'dsMessageResourcePage'"
      :columns="defaultGridData0.columns"
      :showDisplayCountControl="false"
    />
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMU_00003_T02', // eslint-disable-line vue/name-property-casing
  pname: 'PGE_CMU_00003',
  extends: BasePage,
  props: {
    messageResourcesId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      pageName: this.$t('MSG_TXT_MSG_RESO_RGST_PAGE'),
      frame0: {
        data: {},
      },
      localdata: [],
      defaultGridData0: {
        dataSource: {
          datafields: [],
          datatype: 'array',
        },
        columns: [{
          text: this.$t('MSG_TXT_MDLE'),
          datafield: 'moduleName',
          width: '100px',
        }, {
          text: this.$t('MSG_TXT_SMDLE'),
          datafield: 'subModuleName',
          width: '100px',
        }, {
          text: this.$t('MSG_TXT_TYPE'),
          datafield: 'pageTypeName',
          width: '100px',
        }, {
          text: this.$t('MSG_TXT_PAGE_ID'),
          datafield: 'pageId',
          width: '150px',
        }, {
          text: this.$t('MSG_TXT_PAGE_NM'),
          datafield: 'pageName',
        }, {
          text: this.$t('MSG_TXT_STT'),
          datafield: 'pageStatusName',
          width: '100px',
        }],
      },
    };
  },
  computed: { // 계산된 속성, property로 사용가능
  },
  watch: { // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
    messageResourcesId(obj) {
      if (!this._inactive) {
        if (!utils.isEmpty(obj)) {
          this.selectDataFormInput();
        } else {
          this.localdata = [];
        }
      }
    },
  },
  activated() {
    if (this.messageResourcesId) {
      this.selectDataFormInput();
    } else {
      this.localdata = [];
    }
  },
  mounted() { // DOM이 document에 append된 상태, 실제 element에 접근 가능 (this.$el or this.$refs)
    // 주로 데이터 패치 등을 함
    if (this.messageResourcesId) {
      this.selectDataFormInput();
    } else {
      this.localdata = [];
    }
  },
  methods: {
    loadCode() {
    },
    loadData() { // get contents data, grid etc..
    },
    selectDataFormInput() {
      http.request(this.$options.pname, 'DTS_CMU_00014', {
        path: {
          'message-resource-id': this.messageResourcesId,
        },
      }).then(res => {
        if (res.data.length > 0) {
          this.dsMessageResourcePage.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
        } else {
          this.dsMessageResourcePage.setRawData([]); // 데이터 셋에 데이터를 넣는 함수
        }
      });
    },
  },
  datasets: [{
    id: 'dsMessageResourcePage',
    type: 'local',
    data: 'localdata',
    datafields: [
      { name: 'moduleCode', type: 'string', map: 'moduleCode' },
      { name: 'subModuleCode', type: 'string', map: 'subModuleCode' },
      { name: 'pageTypeCode', type: 'string', map: 'pageTypeCode' },
      { name: 'pageId', type: 'string', map: 'pageId' },
      { name: 'pageName', type: 'string', map: 'pageName' },
      { name: 'pageStatusCode', type: 'string', map: 'pageStatusCode' },
      { name: 'moduleName', type: 'string', map: 'moduleName' },
      { name: 'subModuleName', type: 'string', map: 'subModuleName' },
      { name: 'pageTypeName', type: 'string', map: 'pageTypeName' },
      { name: 'pageStatusName', type: 'string', map: 'pageStatusName' },
    ],
  }],
};
</script>
<style scoped>
</style>
